
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Stats from "../components/Stats";
import FAQ from "../components/FAQ";
import Footer from "../components/Footer";
import Testimonials from "../components/Testimonials";
import WealthSection from "../components/WealthSection";
import ScrollTriggeredPopup from "../components/ScrollTriggeredPopup";
import { Button } from "@/components/ui/button";

const Index = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      <Hero />
      <WealthSection />
      <Stats />
      <FAQ />
      <Testimonials />
      <div className="mt-8 mb-16 mx-auto px-4 md:px-6 max-w-[1200px]">
        <div className="w-full border-2 border-[#27B5FC] bg-[#27B5FC] rounded-xl md:rounded-2xl">
          <div className="text-center space-y-4 md:space-y-6 p-6 md:p-8">
            <h2 className="text-4xl md:text-6xl font-charter font-medium text-white leading-tight">
              Ready to get<br />started today?
            </h2>
            <div className="flex flex-col sm:flex-row justify-center gap-4">
              <Button 
                className="w-full md:w-auto bg-[#FAF9F8] hover:bg-[#104B60] text-black hover:text-white px-4 md:px-6 py-3 md:py-4 text-base md:text-lg h-auto rounded-full transition-colors"
                onClick={() => window.location.href = 'https://app.plannifi.com/auth/sign-up'}
              >
                Get Started
              </Button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
      <ScrollTriggeredPopup scrollThreshold={30} delay={1500} />
    </div>
  );
};

export default Index;
